import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { PhoneCall, Globe2 } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';

  const handleNavClick = (path, isAnchor) => {
    if (isAnchor && isHome) {
      const id = path.split('#')[1];
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate(path);
    }
  };

  return (
    <footer className="bg-slate-950 text-slate-400 py-16 px-4 sm:px-6 lg:px-8 border-t-4 border-indigo-600">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
        <div className="col-span-1 md:col-span-1">
          <div className="cursor-pointer mb-6" onClick={() => navigate('/')}>
            <img src="/images/logoAuth.png" alt="Flywell Logistics" className="h-8 md:h-10 brightness-0 invert opacity-90" />
          </div>
          <p className="text-sm leading-relaxed mb-6">
            Flywell is building an all-in-one tech & service stack for the entire eCommerce value chain.
          </p>
        </div>

        <div>
          <h3 className="text-white font-bold mb-6 tracking-wide uppercase text-sm">Services</h3>
          <ul className="space-y-4 text-sm font-medium">
            <li><button onClick={() => handleNavClick('/#solutions', true)} className="hover:text-indigo-400 transition-colors">Domestic Shipping</button></li>
            <li><button onClick={() => handleNavClick('/#solutions', true)} className="hover:text-indigo-400 transition-colors">B2B Cargo Shipping</button></li>
            <li><button onClick={() => handleNavClick('/#solutions', true)} className="hover:text-indigo-400 transition-colors">Warehouse & Fulfillment</button></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-bold mb-6 tracking-wide uppercase text-sm">Features</h3>
          <ul className="space-y-4 text-sm font-medium">
            <li><button onClick={() => handleNavClick('/#features', true)} className="hover:text-indigo-400 transition-colors">Branded Tracking Page</button></li>
            <li><button onClick={() => handleNavClick('/#features', true)} className="hover:text-indigo-400 transition-colors">NDR Management</button></li>
            <li><button onClick={() => handleNavClick('/#features', true)} className="hover:text-indigo-400 transition-colors">Early Payouts</button></li>
          </ul>
        </div>

        <div>
          <h3 className="text-white font-bold mb-6 tracking-wide uppercase text-sm">Contact Us</h3>
          <ul className="space-y-4 text-sm font-medium">
            <li className="flex items-start gap-3">
              <PhoneCall className="w-5 h-5 text-indigo-500 shrink-0" />
              <span>+918826885557</span>
            </li>
            <li className="flex items-start gap-3">
              <Globe2 className="w-5 h-5 text-indigo-500 shrink-0" />
              <span>support@flywelllogistics.com</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm font-medium">
        <p>&copy; {new Date().getFullYear()} Flywell Logistics. All rights reserved.</p>
        <div className="flex gap-6">
          <button onClick={() => navigate('/privacy-policy')} className="hover:text-white transition-colors">Privacy Policy</button>
          <button onClick={() => navigate('/terms-conditions')} className="hover:text-white transition-colors">Terms of Service</button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
